<app-imagecloud [data]="data"></app-imagecloud>
 